import { useState } from "react";
import api, { API } from "@/lib/api";
import { Play } from "lucide-react";

const abs = (u) => (!u ? "" : u.startsWith("http") ? u : `${API.replace("/api", "")}${u}`);

export default function ProposalVideoPlayer({ video, token }) {
  const [playing, setPlaying] = useState(false);
  if (!video || !(video.embed_url || video.url)) return null;
  const heading = video.heading || "A quick message about your proposal";
  const isFile = video.type === "upload" || video.provider === "file";
  const src = isFile ? abs(video.url) : video.embed_url || video.url;

  const play = () => {
    setPlaying(true);
    api.post(`/public/proposals/${token}/video-played`).catch(() => {});
  };

  const embedSrc = () => {
    const sep = src.includes("?") ? "&" : "?";
    if (video.provider === "loom") return `${src}${sep}autoplay=1`;
    if (video.provider === "youtube") return `${src}${sep}autoplay=1&rel=0`;
    if (video.provider === "vimeo") return `${src}${sep}autoplay=1`;
    return src;
  };

  return (
    <div className="max-w-[840px] mx-auto mb-4" data-testid="proposal-video">
      <div className="bg-cass-navy rounded-2xl overflow-hidden shadow-xl ring-1 ring-black/5">
        <div className="px-6 pt-5 pb-3">
          <div className="text-cass-teal text-xs font-semibold uppercase tracking-widest">Personal message</div>
          <h3 className="text-white font-alt text-lg mt-0.5">{heading}</h3>
        </div>
        <div className="relative bg-black aspect-video">
          {!playing ? (
            <button type="button" onClick={play} data-testid="proposal-video-play"
              className="absolute inset-0 w-full h-full grid place-items-center group cursor-pointer">
              <span className="w-16 h-16 rounded-full bg-cass-teal/90 group-hover:bg-cass-teal grid place-items-center transition-colors">
                <Play className="w-7 h-7 text-white ml-1" fill="white" />
              </span>
            </button>
          ) : isFile ? (
            <video src={src} controls autoPlay className="w-full h-full" data-testid="proposal-video-file" />
          ) : (
            <iframe src={embedSrc()} title="Proposal video" allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen className="w-full h-full absolute inset-0" data-testid="proposal-video-iframe" />
          )}
        </div>
      </div>
    </div>
  );
}
